import { z } from "zod";
import { createFileRoute } from "@tanstack/react-router";
import { requireAuth } from "@/lib/middleware";
import { LineItemsList } from "@/features/organizations/settings/line-items/line-items-list";
import { Main } from "@/components/layout/main";
import { authClient } from "@/lib/auth";

export const Route = createFileRoute(
  "/_authenticated/_organization/organizations/settings/line-items"
)({
  beforeLoad: async () => {
    await requireAuth();
  },
  component: LineItemsPage,
});

function LineItemsPage() {
  const { data: activeOrganization, isPending } = authClient.useActiveOrganization();

  if (isPending) {
    return (
      <Main>
        <div className="py-8 text-center">
          <p className="text-muted-foreground">Loading organization...</p>
        </div>
      </Main>
    );
  }

  return (
    <Main>
      <LineItemsList organizationId={activeOrganization?.id || ''} />
    </Main>
  );
}

